/* Bodi — show the running total on standard Dawn Add-to-cart buttons:
   "Add to cart · $XX.XX" = current variant price × quantity. Re-applies on
   quantity change and on Dawn's variant re-render. Skips the custom scent
   selectors (they manage their own total) and sold-out / disabled states. */
(function () {
  function priceText(scope) {
    var el =
      scope.querySelector('.price__sale .price-item--sale') ||
      scope.querySelector('.price__regular .price-item--regular') ||
      scope.querySelector('.price-item--regular') ||
      scope.querySelector('.price-item');
    return el ? el.textContent.trim() : '';
  }

  function update(form) {
    var btn = form.querySelector('.product-form__submit');
    if (!btn || btn.hasAttribute('data-bsp-atc') || btn.hasAttribute('data-brb-atc')) return;
    if (btn.disabled || btn.getAttribute('aria-disabled') === 'true') return;

    var scope = form.closest('product-info') || document;
    var raw = priceText(scope).replace(/from/i, '');
    var m = raw.match(/(\D*)([\d.,]+)(.*)/);
    if (!m) return;
    var prefix = m[1].trim();
    var num = parseFloat(m[2].replace(/,/g, ''));
    var suffix = m[3];
    if (isNaN(num)) return;

    var qEl = scope.querySelector('.quantity__input');
    var qty = qEl ? (parseInt(qEl.value, 10) || 1) : 1;
    var span = btn.querySelector('span');
    if (!span) return;

    var label = 'Add to cart · ' + prefix + (num * qty).toFixed(2) + suffix;
    if (span.textContent !== label) span.textContent = label;
  }

  function run() {
    document.querySelectorAll('product-form form').forEach(update);
  }

  function start() {
    run();
    document.querySelectorAll('product-info').forEach(function (pi) {
      new MutationObserver(function () {
        clearTimeout(window.__bodiAtcT);
        window.__bodiAtcT = setTimeout(run, 80);
      }).observe(pi, { childList: true, subtree: true });
    });
  }

  document.addEventListener('change', function (e) {
    if (e.target && e.target.classList && e.target.classList.contains('quantity__input')) run();
  });
  document.addEventListener('input', function (e) {
    if (e.target && e.target.classList && e.target.classList.contains('quantity__input')) run();
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
